import { FormEditorTypes } from "@/components/forms/form-editor.config.ts";
import { FormEditor } from "@/components/forms/FormEditor.tsx";
import { ScoreCardEditSidebar } from "@/pages/recruit/scorecards/edit/components/ScoreCardEditSidebar.tsx";
import {
  ScoreCardsEditPageStep,
  useScoreCardEditPage,
} from "@/pages/recruit/scorecards/edit/components/scorecards-edit-pages.tsx";
import { ScoreCardEditPageProps } from "@/pages/recruit/scorecards/edit/scorecards-edit.ts";
import { useScoreCardPublish } from "@/queries/recruit/use-scorecards.query.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { Button, FullScreenPage, Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function ScoreCardEditQuestionsPage({ scoreCard }: ScoreCardEditPageProps) {
  const { t } = useTranslation();
  const scoreCardPublish = useScoreCardPublish();
  const { navigateToStep, confirmExit } = useScoreCardEditPage();
  const navigate = useNavigate();

  const publish = async () => {
    if (!scoreCard) return;

    const result = await scoreCardPublish.mutateAsync({ id: scoreCard.id });

    if (!result.success) return;

    analyticsService.trackEvent(analyticEvents.scoreCards.published, {
      [analyticProperties.id]: scoreCard.id,
    });

    navigate("/recruitment/scorecards");
  };

  return (
    <FullScreenPage
      title={t("scorecards:scorecard")}
      isCenterVertical={false}
      backSlot={
        <Button variant={"secondary"} size={"lg"} onClick={confirmExit}>
          {t("common:exit")}
        </Button>
      }
      actionsSlot={
        <Stack direction={"horizontal"} gap={"sm"}>
          <Button
            variant={"secondary"}
            size={"lg"}
            onClick={() => {
              navigateToStep(scoreCard.id, ScoreCardsEditPageStep.details);
            }}
          >
            {t("common:back")}
          </Button>
          <Button size={"lg"} onClick={publish} isLoading={scoreCardPublish.isPending}>
            {t("common:save")}
          </Button>
        </Stack>
      }
      sidebarSlot={
        <ScoreCardEditSidebar step={ScoreCardsEditPageStep.questions} scoreCard={scoreCard} />
      }
    >
      <Stack gap={"lg"} justify={"center"}>
        {scoreCard && <FormEditor type={FormEditorTypes.scoreCard} id={scoreCard.id} />}
      </Stack>
    </FullScreenPage>
  );
}
